import { ReactElement, HtmlHTMLAttributes } from 'react';
import { BounceLoader } from 'react-spinners';

import { useTheme } from 'hooks/useTheme';

import { LoaderContainer } from './styles';

interface ILoaderType {
  color?: string;
  disabeldPadding?: boolean;
}

const Loader: React.FC<HtmlHTMLAttributes<HTMLDivElement> & ILoaderType> = ({
  color,
  disabeldPadding = false,
  ...rest
}): ReactElement => {
  const { theme } = useTheme();

  return (
    <LoaderContainer {...rest} disabeldPadding={disabeldPadding}>
      <BounceLoader size={20} color={color || theme.colors.primary.color} loading />
    </LoaderContainer>
  );
};

export default Loader;
